<template>
  <el-dialog
    :title="
      model.id
        ? `编辑 ${commodityCategory.name} 出库`
        : `添加 ${commodityCategory.name} 出库`
    "
    :visible.sync="visible"
    width="500px"
    @close="$emit('update:show', false)"
    :close-on-click-modal="false"
  >
    <el-form
      :model="model"
      :rules="rules"
      ref="form"
      label-width="100px"
      size="small"
    >
      <el-form-item label="材料信息" prop="item_id">
        <ItemSelect
          v-model="model.item_id"
          :commodityCategory="commodityCategory.id"
          v-if="visible && model.created"
        ></ItemSelect>
        <!-- <el-select
          style="width: 100%"
          size="small"
          placeholder="请搜索存货编码、规格、型号等"
          filterable
          remote
          :remote-method="getItems"
          :loading="loading"
          v-model="model.item_id"
        >
          <el-option
            v-for="item in items"
            :key="item.id"
            :label="`${item.code}（${item.name}，${item.specification}，${item.model_number}）`"
            :value="parseInt(item.id)"
          ></el-option>
        </el-select>
        <div class="font-12 text-info mt-5" style="line-height: 1em">
          {{
            `选项格式为：编码（名称，规格，${
              commodityCategory.id == 2 ? '倒角' : '型号'
            }）`
          }}
        </div> -->
      </el-form-item>
      <el-form-item label="新 / 旧" prop="category">
        <el-select v-model="model.category" style="width: 100%" disabled>
          <el-option key="1" label="新" :value="1"></el-option>
          <el-option key="2" label="旧" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="出库类型" prop="stock_out_category">
        <el-select v-model="model.stock_out_category" style="width: 100%">
          <el-option
            v-for="(value, index) in ItemStockOutCategoryMap"
            :key="index"
            :label="value"
            :value="parseInt(index)"
          ></el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item
        label="收货仓库"
        prop="stock_out_stockroom_id"
        v-if="model.stock_out_category == 2"
      >
        <el-select v-model="model.stock_out_stockroom_id" style="width: 100%">
          <el-option
            v-for="item in stockrooms"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item
        label="钻头序列号"
        prop="drills"
        v-if="model.stock_out_category == 1"
      >
        <DrillSelect
          v-model="model.drills"
          v-if="visible && model.created"
        ></DrillSelect>
        <!-- <el-input
          class="fix-width"
          v-model="model.drill_serial_numbers"
        ></el-input> -->
      </el-form-item>
      <el-form-item label="数量" prop="number">
        <el-input-number
          v-model="model.number"
          :min="1"
          :max="1000000"
          :step="1"
        ></el-input-number>
      </el-form-item>

      <!-- <el-form-item label="物流公司" prop="logistic_company">
        <ShipperSelect v-model="model.logistic_company"></ShipperSelect>
      </el-form-item>
      <el-form-item label="物流单号" prop="logistic_number">
        <el-input
          placeholder="物流单号"
          v-model="model.logistic_number"
        ></el-input>
      </el-form-item> -->
      <!-- <el-form-item label="收件人手机号" prop="receiver_mobile">
        <el-input
          placeholder="使用顺丰时必填"
          v-model="model.receiver_mobile"
        ></el-input>
      </el-form-item> -->
      <el-form-item label="备注" prop="remark">
        <el-input type="textarea" v-model="model.remark"></el-input>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button size="small" type="primary" @click="submitForm"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import {
  itemOutRecordNew,
  itemOutRecordUpdate,
  itemList,
  stockroomList,
} from '@/service/getData'
import { ItemStockOutCategoryMap } from '@/config/global'
import DrillSelect from '@/components/select/drill_multiple_select'
import ShipperSelect from '@/components/select/shipper_select'
import ItemSelect from '@/components/select/item_select'

export default {
  components: {
    DrillSelect,
    ShipperSelect,
    ItemSelect,
  },
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
    commodityCategory: {
      type: Object,
      default() {
        return {
          id: 0,
          name: '',
        }
      },
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
        this.model.drills = null
      }
    },
  },
  data() {
    return {
      ItemStockOutCategoryMap,
      items: [],
      loading: false,
      visible: this.show,
      rules: {
        item_id: [{ required: true, message: '请选择零件' }],
        stock_out_stockroom_id: [{ required: true, message: '请选择收货仓库' }],
      },
      stockrooms: [],
    }
  },
  created() {
    this.getStockrooms()
  },
  methods: {
    async getStockrooms() {
      let res = await stockroomList()
      if (res.status == 0) {
        this.stockrooms = res.data.list
      }
    },
    async getItems(query, item_id = 0) {
      if (query !== '' || item_id > 0) {
        this.loading = true
        let res = await itemList({
          query: query,
          item_id: item_id,
          commodity_category: this.commodityCategory.id,
        })
        if (res.status == 0) {
          this.items = res.data.list
          this.loading = false
        }
      } else {
        this.items = []
      }
    },
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          let data = this.model
          data.drill_serial_numbers = data.drills.join(',')
          if (this.model.id > 0) {
            let res = await itemOutRecordUpdate(data)
            if (res.status == 0) {
              this.$emit('callback', res.data)
            }
          } else {
            let res = await itemOutRecordNew(data)
            if (res.status == 0) {
              this.$emit('callback', res.data)
            }
          }
          this.visible = false
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
  },
}
</script>